(function (root, factory) {
  'use strict';
  var ui = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = ui;
  else if (root) root.WTXFirstOrderPhotoUI = ui;
}(typeof window !== 'undefined' ? window : null, function (root) {
  'use strict';

  var defaults = {
    title: 'Have the food bag handy?',
    subtitle: 'Read the ingredient panel from a photo, then check the result.',
    open: 'Use an ingredient photo',
    close: 'Close photo reader',
    choose: 'Choose an ingredient photo',
    choose_another: 'Choose another photo',
    guidance: 'Photograph the ingredient list close up, in good light. Keep the words straight and in focus.',
    formats: 'JPEG, PNG or WebP, up to 12 MB.',
    privacy: 'Your photo is read on your device. Recognition software downloads on first use. The photo is not uploaded.',
    preview: 'Your selected ingredient photo',
    rotate: 'Rotate photo',
    read: 'Read this photo',
    cancel: 'Cancel reading',
    loading: 'Loading the photo reader…',
    reading: 'Reading the ingredient panel…',
    reading_percent: 'Reading the ingredient panel… {percent}%',
    ready: 'Check the words below against the ingredient panel.',
    text: 'Ingredient text you can correct',
    text_help: 'Fix any missed words. Keep the ingredient order shown on the label.',
    manual: 'Or type the ingredient list',
    choice: 'Which named animal ingredient comes first?',
    choice_help: 'Choose from the words in the reviewed ingredient list.',
    both: 'Both beef and chicken',
    other_found: 'Other animal ingredients found',
    fat_or_oil: 'fat or oil',
    flavor: 'flavor',
    unspecified: 'source not specified',
    confirmation: 'I checked this text and my choice against the ingredient panel.',
    apply: 'Use these confirmed ingredients',
    applied: 'Your current-food answers have been updated. Continue with the guide below.',
    skip: 'Continue without a photo',
    review_needed: 'The photo needs a closer review. Correct the text, choose another photo or continue manually.',
    error_unsupported_format: 'Use a JPEG, PNG or WebP photo. For HEIC, save a JPEG or take a screenshot.',
    error_file_too_large: 'Choose a photo smaller than 12 MB.',
    error_empty_file: 'This file is empty. Choose another photo.',
    error_image_too_large: 'Crop the image to the ingredient panel and try again.',
    error_image_too_small: 'Move closer to the ingredient panel and take a sharper photo.',
    error_unreadable_image: 'This image could not be opened. Choose another photo.',
    error_unreadable: 'We could not read this clearly enough. Retake it in better light, rotate it, or type the ingredients.',
    error_ingredients_not_found: 'The ingredient panel was not found. Use a close photo of the ingredient list, or type it.',
    error_no_named_animal_ingredient: 'No animal ingredient was identified. Review the text or choose your current food manually.',
    error_recognition_timeout: 'Photo reading took too long. Retry with a close photo of the ingredient panel, or type the ingredients.',
    error_runtime_unavailable: 'Photo reading is unavailable right now. Retry or enter the ingredients yourself.',
    error_recognition_failed: 'Photo reading is unavailable right now. Retry or enter the ingredients yourself.',
    error_unsupported_browser: 'Photo reading is not available in this browser. Type the ingredient list or choose your current food manually.',
    error_choose_visible_ingredient: 'Select an animal ingredient shown in the reviewed text.',
    error_confirmation_required: 'Check the text and your choice against the label before applying them.',
    error_reader_busy: 'Finish or cancel the current photo scan first.',
    error_cancelled: 'Photo reading cancelled.',
    error_text_too_long: 'Keep only the ingredient list, up to 3,000 characters.',
    error_invalid_rotation: 'Rotate the photo in quarter turns and try again.'
  };

  function create(initialOptions) {
    var options = initialOptions || {};
    var host = null;
    var runtimeKey = '';
    var copy = Object.assign({}, defaults, options.copy || {});
    var state = {
      open: false, file: null, preview: '', rotation: 0, text: '', choice: '', confirmed: false,
      busy: false, status: '', error: '', controller: null, pending: null, version: 0,
      manual: false, applied: false, progress: null
    };
    var refs = {};
    var doc = root && root.document;
    function text(key) { return copy[key] || key; }
    function el(tag, className, value) {
      var node = doc.createElement(tag);
      if (className) node.className = className;
      if (value !== undefined) node.textContent = value;
      return node;
    }
    function button(label, handler, className) {
      var node = el('button', className || 'wfo-photo-link', label);
      node.type = 'button';
      node.addEventListener('click', handler);
      return node;
    }
    function stop() {
      state.version++;
      if (state.controller) state.controller.abort();
      state.controller = null;
      state.busy = false;
    }
    function releasePhoto() {
      if (state.preview) root.URL.revokeObjectURL(state.preview);
      state.preview = '';
      state.file = null;
      state.rotation = 0;
    }
    function errorText(code) { return text('error_' + code) === 'error_' + code ? text('error_recognition_failed') : text('error_' + code); }
    function parse() { return root.WTXFirstOrderLabel.analyze(state.text, { confirmedIngredientText: true }); }
    function updateStatus() {
      if (!refs.status) return;
      refs.status.textContent = state.error ? errorText(state.error) : state.status;
      refs.status.classList.toggle('is-warning', Boolean(state.error));
      refs.status.hidden = !state.error && !state.status;
      if (refs.progress) {
        refs.progress.hidden = !state.busy;
        if (state.progress === null) refs.progress.removeAttribute('value');
        else refs.progress.value = state.progress;
      }
    }
    function updateApply() {
      var parsed = parse();
      if (refs.apply) refs.apply.disabled = state.busy || state.applied || !state.confirmed || !state.choice || Boolean(parsed.error);
      if (refs.confirm) refs.confirm.checked = state.confirmed;
    }
    function updateChoices() {
      if (!refs.choices) return;
      var parsed = parse();
      var candidates = parsed.primaryCandidates || [];
      var ids = candidates.map(function (item) { return item.id; });
      var candidatesWithBoth = candidates.slice();
      if (ids.includes('beef') && ids.includes('chicken')) candidatesWithBoth.push({ id: 'both', label: text('both') });
      if (!candidatesWithBoth.some(function (item) { return item.id === state.choice; })) state.choice = '';
      refs.choices.replaceChildren();
      refs.choiceGroup.hidden = !candidatesWithBoth.length;
      candidatesWithBoth.forEach(function (item) {
        var choice = el('label', 'wfo-photo-choice');
        var radio = el('input');
        radio.type = 'radio';
        radio.name = 'wtx-photo-animal';
        radio.value = item.id;
        radio.checked = state.choice === item.id;
        radio.disabled = state.busy;
        radio.addEventListener('change', function () {
          state.choice = item.id;
          state.confirmed = false;
          state.applied = false;
          updateApply();
        });
        choice.append(radio, el('span', '', item.label));
        refs.choices.append(choice);
      });
      var other = (parsed.animalIngredients || []).filter(function (item) { return ['fat_or_oil', 'flavor'].includes(item.role); });
      refs.other.hidden = !other.length;
      refs.other.textContent = other.length ? text('other_found') + ': ' + other.map(function (item) { return item.label + ' (' + text(item.role) + ')'; }).join(', ') + '.' : '';
      refs.confirmLabel.hidden = !candidatesWithBoth.length;
      refs.apply.hidden = !candidatesWithBoth.length;
      refs.noAnimal.hidden = !state.text.trim() || !parsed.error;
      refs.noAnimal.textContent = parsed.error ? errorText(parsed.error) : '';
      updateApply();
    }
    async function scan() {
      if (!state.file) return;
      var previous = state.pending;
      stop();
      var version = state.version;
      state.busy = true;
      state.error = '';
      state.status = text('loading');
      state.progress = null;
      state.confirmed = false;
      state.applied = false;
      state.controller = new root.AbortController();
      render();
      var operation = (async function () {
        if (previous) { try { await previous; } catch (_) {} }
        if (version !== state.version) return;
        var result = await root.WTXFirstOrderLabel.recognize(state.file, {
          rotation: state.rotation,
          signal: state.controller.signal,
          onProgress: function (event) {
            if (version !== state.version) return;
            var reading = /recognizing text/.test(event.status);
            var percent = Math.floor(event.progress * 10) * 10;
            state.progress = reading ? event.progress : null;
            var message = reading ? text('reading_percent').replace('{percent}', String(percent)) : text('loading');
            if (message !== state.status) { state.status = message; updateStatus(); }
          }
        });
        if (version !== state.version) return;
        state.text = result.ingredientsText || result.text || '';
        state.choice = '';
        state.error = result.error || '';
        state.status = result.error ? '' : text('ready');
        state.manual = true;
      }());
      state.pending = operation;
      try { await operation; }
      catch (error) { if (version === state.version) { state.error = error.code || 'recognition_failed'; state.status = ''; } }
      finally {
        if (version === state.version) {
          state.busy = false;
          state.controller = null;
          state.progress = null;
          state.pending = null;
          render();
        }
      }
    }
    async function apply() {
      var result = root.WTXFirstOrderLabel.confirm({ text: state.text, primaryProtein: state.choice, confirmed: state.confirmed });
      if (result.error) { state.error = result.error; updateStatus(); return; }
      if (typeof result.ingredientsText !== 'string' || result.ingredientsText.length > 3000) { state.error = 'text_too_long'; updateStatus(); return; }
      if (typeof options.onApply !== 'function') { state.error = 'runtime_unavailable'; updateStatus(); return; }
      state.applied = true;
      state.error = '';
      state.status = text('applied');
      try { if (await options.onApply(result) === false) throw Error('rejected'); }
      catch (_) { state.applied = false; state.error = 'recognition_failed'; }
      render();
    }
    function render() {
      if (!host || !doc) return;
      var panel = el('section', 'wfo-photo');
      var header = el('div', 'wfo-photo-heading');
      var intro = el('div');
      intro.append(el('h3', '', text('title')), el('p', '', text('subtitle')));
      var toggle = button(text(state.open ? 'close' : 'open'), function () {
        state.open = !state.open;
        if (!state.open && state.busy) { stop(); state.error = 'cancelled'; }
        render();
      }, 'wfo-photo-toggle');
      toggle.setAttribute('aria-expanded', String(state.open));
      header.append(intro, toggle);
      panel.append(header);
      refs = {};
      if (state.open) {
        var body = el('div', 'wfo-photo-body');
        body.append(el('p', 'wfo-photo-guidance', text('guidance')));
        var fileLabel = el('label', 'wfo-photo-upload');
        var file = el('input');
        file.type = 'file';
        file.accept = 'image/jpeg,image/png,image/webp';
        file.setAttribute('aria-label', text('choose'));
        file.addEventListener('change', function () {
          var chosen = file.files && file.files[0];
          if (!chosen) return;
          stop(); releasePhoto();
          state.file = chosen;
          if (['image/jpeg', 'image/png', 'image/webp'].includes(chosen.type) && chosen.size <= 12 * 1024 * 1024) state.preview = root.URL.createObjectURL(chosen);
          state.text = ''; state.choice = ''; state.confirmed = false; state.applied = false;
          void scan();
        });
        fileLabel.append(el('strong', '', text(state.file ? 'choose_another' : 'choose')), el('span', '', text('formats')), file);
        body.append(fileLabel);
        if (state.preview) {
          var preview = el('div', 'wfo-photo-preview');
          var image = el('img');
          image.src = state.preview;
          image.alt = text('preview');
          image.style.transform = 'rotate(' + state.rotation + 'deg)';
          preview.append(image);
          body.append(preview);
        }
        if (state.file) {
          var controls = el('div', 'wfo-photo-actions');
          var rotate = button(text('rotate'), function () { state.rotation = (state.rotation + 90) % 360; void scan(); });
          rotate.disabled = state.busy;
          var read = button(text('read'), function () { void scan(); });
          read.disabled = state.busy;
          controls.append(rotate, read);
          if (state.busy) controls.append(button(text('cancel'), function () { stop(); state.error = 'cancelled'; state.status = ''; render(); }));
          body.append(controls);
        }
        refs.status = el('p', 'wfo-photo-status');
        refs.status.setAttribute('role', 'status');
        refs.status.setAttribute('aria-live', 'polite');
        refs.progress = el('progress', 'wfo-photo-progress');
        refs.progress.max = 1;
        refs.progress.setAttribute('aria-label', text('reading'));
        body.append(refs.status, refs.progress);
        if (!state.manual && !state.text) body.append(button(text('manual'), function () { stop(); state.manual = true; state.error = ''; state.status = ''; render(); refs.textarea?.focus(); }));
        if (state.manual || state.text) {
          var textLabel = el('label', 'wfo-photo-text');
          textLabel.append(el('strong', '', text('text')), el('span', '', text('text_help')));
          refs.textarea = el('textarea');
          refs.textarea.rows = 5;
          refs.textarea.maxLength = 3000;
          refs.textarea.value = state.text;
          refs.textarea.spellcheck = false;
          refs.textarea.disabled = state.busy;
          refs.textarea.addEventListener('input', function () {
            state.text = refs.textarea.value;
            state.confirmed = false; state.applied = false; state.error = ''; state.status = '';
            updateChoices(); updateStatus();
          });
          textLabel.append(refs.textarea);
          body.append(textLabel);
          refs.choiceGroup = el('fieldset', 'wfo-photo-candidates');
          refs.choiceGroup.append(el('legend', '', text('choice')), el('p', '', text('choice_help')));
          refs.choices = el('div', 'wfo-photo-choices');
          refs.choiceGroup.append(refs.choices);
          refs.other = el('p', 'wfo-photo-secondary');
          refs.noAnimal = el('p', 'wfo-photo-status is-warning');
          body.append(refs.choiceGroup, refs.other, refs.noAnimal);
          refs.confirmLabel = el('label', 'wfo-photo-confirm');
          refs.confirm = el('input');
          refs.confirm.type = 'checkbox';
          refs.confirm.disabled = state.busy;
          refs.confirm.addEventListener('change', function () { state.confirmed = refs.confirm.checked; state.applied = false; updateApply(); });
          refs.confirmLabel.append(refs.confirm, el('span', '', text('confirmation')));
          refs.apply = button(text('apply'), function () { void apply(); }, 'wfo-photo-apply');
          body.append(refs.confirmLabel, refs.apply);
        }
        body.append(el('p', 'wfo-photo-privacy', text('privacy')));
        body.append(button(text('skip'), function () { stop(); releasePhoto(); state.open = false; render(); }));
        panel.append(body);
      }
      host.replaceChildren(panel);
      updateStatus();
      if (refs.choices) updateChoices();
    }
    return {
      mount: function (container, newOptions) {
        if (!container || !root?.WTXFirstOrderLabel) return false;
        options = Object.assign({}, options, newOptions || {});
        copy = Object.assign({}, defaults, options.copy || {});
        var config = options.runtime;
        if (!config) { try { config = JSON.parse(doc.querySelector('[data-wfo-ocr]')?.textContent || 'null'); } catch (_) {} }
        var key = JSON.stringify(config);
        if (config && key !== runtimeKey) { stop(); root.WTXFirstOrderLabel.configure(config); runtimeKey = key; }
        host = container;
        if (state.applied && typeof options.getCurrent === 'function') {
          var current = options.getCurrent() || {};
          var expected = ['chicken', 'beef', 'both'].includes(state.choice) ? state.choice : 'other';
          if (current.protein !== expected || current.labelConfirmed !== 'yes') { state.applied = false; state.status = ''; state.confirmed = false; }
        }
        render();
        return true;
      },
      unmount: function () { var wasBusy = state.busy; stop(); releasePhoto(); if (wasBusy) { state.status = ''; state.error = 'cancelled'; } host = null; refs = {}; },
      reset: function () {
        stop(); releasePhoto();
        state.open = false; state.text = ''; state.choice = ''; state.confirmed = false;
        state.error = ''; state.status = ''; state.applied = false; state.manual = false;
        render();
      },
      destroy: function () { this.reset(); if (host) host.replaceChildren(); host = null; refs = {}; }
    };
  }

  var instance = null;
  return {
    defaults: defaults,
    create: create,
    mount: function (node, options) { if (!instance) instance = create(); return instance.mount(node, options); },
    unmount: function () { if (instance) instance.unmount(); },
    reset: function () { if (instance) instance.reset(); },
    destroy: function () { if (instance) instance.destroy(); instance = null; }
  };
}));
